import React from 'react';
import {Box} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const colorFor = (variant) => {
    switch (variant) {
        case 'success': return t.color.status.successSolid;
        case 'warning': return t.color.status.warningSolid;
        case 'danger':  return t.color.status.dangerSolid;
        case 'info':    return t.color.status.infoSolid;
        case 'neutral':
        default:        return t.color.status.neutralSolid;
    }
};

const StatusDot = ({variant = 'neutral', size = t.dot.size, sx}) => (
    <Box
        component="span"
        sx={{
            display: 'inline-block',
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: colorFor(variant),
            flexShrink: 0,
            ...sx,
        }}
    />
);

export default StatusDot;
